export function truncate(string, size, on_word, suffix) {
  if (on_word == null) { on_word = true; }
  if (suffix == null) { suffix = '...'; }
  if (string.length > size) {
    const wanted_size = size - suffix.length;
    if (on_word) {
      string = string.substring(0, wanted_size);
      string = string.substring(0, string.lastIndexOf(' '));
      return string + suffix;
    }
    return string.substring(0, wanted_size) + suffix;
  }
  return string;
}
